import circleSolid from '../media/chart/CircleSolid.svg';
import circleDotted from '../media/chart/CircleDotted.svg';
import diamondSolid from '../media/chart/DiamondSolid.svg';
import diamondDotted from '../media/chart/DiamondDotted.svg';
import triangleDownSolid from '../media/chart/TriangleDownSolid.svg';
import triangleDownDotted from '../media/chart/TriangleDownDotted.svg';
import triangleUpSolid from '../media/chart/TriangleUpSolid.svg';
import triangleUpDotted from '../media/chart/TriangleUpDotted.svg';

export const getPerformanceGraphStyle = palette => ({
  '.performance-graph': {
    display: 'flex',
    flexDirection: 'column',
    flex: 'auto 1 1',
    flexBasis: '0',
    minHeight: 1,
    '& .performance-graph__graph': {
      flex: 'auto 1 1',
      display: 'flex',
      flexDirection: 'column',

      '& .highcharts-el': {
        fontSize: '12px',
        height: 235,
        overflow: 'visible !important',
        '& > div.highcharts-container': {
          overflow: 'visible !important',
          zIndex: '5 !important',
        },

        '& .highcharts-root': {
          overflow: 'visible',
        },

        '& .highcharts-tooltip': {
          '& .highcharts-label-box.highcharts-tooltip-box': {
            opacity: 0,
          },
          '& > span': {
            zIndex: 1,
          },
          '& .perf-graph-tool-tip': {
            display: 'flex',
            boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            '@supports (backdrop-filter: blur(60px))': {
              backdropFilter: 'blur(60px)',
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
            },
            '& .charts-tooltip': {
              margin: '15px',

              '& .tool-tip-title': {
                marginBottom: '10px',
              },
              '& .tool-tip-properties': {
                display: 'grid',
                fallbacks: {
                  display: '-ms-grid',
                },
                '& .tool-tip-property:nth-child(1)': {
                  '-ms-grid-row': '1',
                  gridRow: '1',
                  '-ms-grid-column': '1',
                  gridColumn: '1',
                  marginRight: '30px',
                },
                '& .tool-tip-property:nth-child(2)': {
                  '-ms-grid-row': '1',
                  gridRow: '1',
                  '-ms-grid-column': '2',
                  gridColumn: '2',
                },
                '& .tool-tip-property:nth-child(3)': {
                  '-ms-grid-row': '2',
                  gridRow: '2',
                  '-ms-grid-column': '1',
                  gridColumn: '1',
                  marginRight: '30px',
                  marginTop: '10px',
                },
                '& .tool-tip-property:nth-child(4)': {
                  '-ms-grid-row': '2',
                  gridRow: '2',
                  '-ms-grid-column': '2',
                  gridColumn: '2',
                  marginTop: '10px',
                },
                '& .tool-tip-property': {
                  display: 'flex',

                  '& .tool-tip-icon': {
                    backgroundRepeat: 'no-repeat',
                    width: 14,
                    height: 40,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    marginRight: '15px',
                  },
                  '& .circle-solid': {
                    backgroundImage: `url("${circleSolid}")`,
                  },
                  '& .circle-shortdash': {
                    backgroundImage: `url("${circleDotted}")`,
                  },
                  '& .diamond-solid': {
                    backgroundImage: `url("${diamondSolid}")`,
                  },
                  '& .diamond-shortdash': {
                    backgroundImage: `url("${diamondDotted}")`,
                  },
                  '& .triangle-down-solid': {
                    backgroundImage: `url("${triangleDownSolid}")`,
                  },
                  '& .triangle-down-shortdash': {
                    backgroundImage: `url("${triangleDownDotted}")`,
                  },
                  '& .triangle-solid': {
                    backgroundImage: `url("${triangleUpSolid}")`,
                  },
                  '& .triangle-shortdash': {
                    backgroundImage: `url("${triangleUpDotted}")`,
                  },

                  '& .tool-tip-details': {

                    '& .tool-tip-value': {
                      fontSize: '16px',
                    },
                  },
                },
              },
            },
          },

          '& .perf-graph-tool-tip.pop': {
            '& .charts-tooltip': {
              margin: '15px',

              '& .tool-tip-properties': {
                display: 'block',

                '& .tool-tip-property + .tool-tip-property': {
                  marginTop: '20px',
                },

                '& .tool-tip-property': {
                  display: 'flex',
                  marginRight: '0px !important',
                },
              },
            },
          },
        },

        '& .highcharts-root+.highcharts-axis-labels.highcharts-xaxis-labels': {
          top: '16px !important',
        },

        '& .highcharts-xaxis-labels+.highcharts-xaxis-labels': {
          marginTop: -10,
        },
        '& .highcharts-el__label--first': {
        },
        '& .highcharts-el__label--last': {
        },
      },
    },
    '& .switcher': {
      flex: 'auto 1 1',
      display: 'flex',
      flexDirection: 'column',
    },
    '& .graph.graph--no-data': {
      margin: '0px 23px 47px 23px',
      borderBottom: `solid 1px ${palette.neutralQuaternaryAlt}`,
      flex: 'auto 1 1',
      display: 'flex',
      justifyContent: 'center',
      backgroundImage: `linear-gradient(${palette.neutralQuaternaryAlt} 1px, transparent 1px)`,
      backgroundSize: '100px 100px',

      '& .graph--no-data__label': {
        marginTop: '80px',
      },
    },
  },
});
